import { PlusIcon } from '@shopify/polaris-icons';
import { Modal, TextField } from './forms';
import { useState } from 'react';
import { Button, BlockStack, Banner } from '@shopify/polaris';
import { useApi } from '../hooks/useApi';
export function CreateLocalProduct({ onCreated }: { onCreated: () => void }) {
  const { fetchApi, loading, error } = useApi();
  const [open,setOpen] = useState(false);
  const [title,setTitle] = useState('');
  const [sku,setSku] = useState('');
  const [barcode,setBarcode] = useState('');
  const [cost,setCost] = useState('');
  return <><Button icon={PlusIcon} onClick={() => setOpen(true)}>Add product</Button><Modal open={open} onClose={() => setOpen(false)} title="Add product" primaryAction={{ icon: PlusIcon, content: 'Create product', loading, disabled: !title.trim() || !sku.trim() || (cost !== '' && (!Number.isFinite(Number(cost)) || Number(cost) < 0)), onAction: async () => {
    const result = await fetchApi<{ success: boolean }>('/products', { method: 'POST', body: JSON.stringify({ title,sku,barcode,...(cost.trim() ? {cost_price:Number(cost)} : {}) }) });
    if (result?.success) { setOpen(false); setTitle(''); setSku(''); setBarcode(''); setCost(''); onCreated(); }
  } }}><Modal.Section><BlockStack gap="300">
    {error && <Banner tone="critical">{error}</Banner>}
    <TextField label="Product name" requiredIndicator value={title} onChange={setTitle} autoComplete="off" />
    <TextField label="SKU" requiredIndicator value={sku} onChange={setSku} autoComplete="off" helpText="Your unique product code" />
    <TextField label="Saved cost price" value={cost} onChange={setCost} type="number" min={0} autoComplete="off" helpText="Optional. Use this warehouse account’s currency." />
    <TextField label="Barcode" value={barcode} onChange={setBarcode} autoComplete="off" helpText="Optional. Scannable EAN, UPC or other code. You can add more barcodes later." />
  </BlockStack></Modal.Section></Modal></>;
}
